/**
 * slickWhatWeOffer 
 * Initial for slick
 */
(($, Drupal, once) => {
    Drupal.behaviors.slickWhatWeOffer = {
      attach() {
        once(
          "slickWhatWeOffer",
          ".media__content .field--name-field-media"
        ).forEach((element) => {
            $(element).slick({
                infinite: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                arrow: true,
                responsive: [
                  {
                    breakpoint: 520,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      arrow: false,
                    },
                  },
                ]
            });
        });
        once(
          "slickWhatWeOffer",
          ".field--name-field-partners"
        ).forEach((element) => {
            $(element).slick({
                infinite: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                vertical: true,
                verticalSwiping: true,
                responsive: [
                  {
                    breakpoint: 520,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      arrow: false,
                    },
                  },
                ]
            });
        });
        once(
          "who-we-are__sectionfive-list-mobile",
          ".who-we-are__sectionfive-list-mobile .field--name-field-clients"
        ).forEach((element) => {
            $(element).slick({
                infinite: false,
                slidesToShow: 1,
                dots: true,
                slidesToScroll: 1,
                initialSlide: 3,
                responsive: [
                  {
                    breakpoint: 520,
                    settings: {
                      slidesToShow: 1,
                      dots: true,
                      slidesToScroll: 1,
                      arrow: false,
                    },
                  },
                ]
            });
        });
      },
    };
  })(jQuery, Drupal, once);
  